import * as React from 'react';
import { connect } from 'react-redux';
import GaranzieActions from './garanzie_actions';
import * as agui from 'arm-gui/dist/controls';

import { Utils, NumberFormatter, domainVal, DateFormatter, i18n, isAuth } from 'arm-common';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import BtnDelete from '../shared/BtnDelete.jsx'
class RegimeFiscaleDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[RegimeFiscaleDetails.jsx] ';
        this.modificaClick = this.modificaClick.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteRF = this.deleteRF.bind(this);
        this.garanziaDetails = this.garanziaDetails.bind(this);
        this.state = {
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        //faccio la chiamata REST per recuperare i dettagli 
        console.log(this.componentName + '[ID] ' + this.props.location.state.id);
        this.props.getRFDetails(this.props.location.state.id);
    }

    modificaClick() {
        this.props.history.push({
            pathname: '/garanzie/createRF', state: {
                id: this.props.regimeFiscale.id,
                modifica: true
            }
        })
    }

    showConfirmPanel() {
        // $("#modalConfirm").modal("show");
        this.setState({ showConfirm: !this.state.showConfirm })
    }
    deleteRF() {

        this.props.deleteRF(this.props.history);

        this.setState({ showConfirm: false });
        // this.props.history.push({ pathname: '/garanzie/details', state: { id: this.props.regimeFiscale.idEntity } })
    }

    garanziaDetails() {
        this.props.history.push({ pathname: '/garanzie/details', state: { id: this.props.regimeFiscale.idEntity } });

    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="card">
                <div className="card-header">
                    <h3>{i18n('ARM.CORE.PRODUCT.REGIME.FISCALE','Dettaglio di Regime Fiscale con id')} {this.props.location.state.id}</h3>
                </div>
                <div className="card-body">
                    {this.props.regimeFiscale ?
                        <div>
                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.ENTITY', 'Entity')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.regimeFiscale.nomeEntity} {this.props.regimeFiscale.idEntity}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DESC_ENTITY', 'Desc Entity')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.regimeFiscale.descEntity}</dd>
                            </dl>
                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.GARANZIE.TIPO_ALIQUOTA', 'Tipo Aliquota')}</dt>
                                <dd className="col-sm-4 col-6">{domainVal('AI_TIPO_ALIQUOTA', this.props.regimeFiscale.codTipoAliquota, this.props.regimeFiscale.codTipoAliquota).desDom}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.GARANZIE.VALORE_ALIQUOTA', 'Valore Aliquota')}</dt>
                                <dd className="col-sm-4 col-6">{(this.props.regimeFiscale.valoreAliquota !== undefined && this.props.regimeFiscale.valoreAliquota !== null) ? this.props.regimeFiscale.valoreAliquota : this.props.regimeFiscale.valoreAliquotaStr}</dd>
                            </dl>
                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.regimeFiscale.insertUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.regimeFiscale.insertDate)}</dd>
                            </dl>

                            <dl className="row">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.regimeFiscale.updateUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.regimeFiscale.updateDate)}</dd>
                            </dl>
                        </div>
                        :
                        null
                    }

                </div>
                <div className="card-footer">
                    <div className="float-left">
                        {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaClick}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmPanel} className=""  ></BtnDelete>
                        }
                        {/* <agui.aButton bs="danger" icon="fas fa-trash-alt" onClick={this.showConfirmPanel} >Elimina</agui.aButton> */}
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.garanziaDetails} >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                </div>

                <ConfirmModalDeleteV4
                    show={this.state.showConfirm}
                    deleteOnClick={this.deleteRF}
                    onClose={this.showConfirmPanel} />
            </div>
        );
    }
};




function mapStateToProps(state, ownProps) {
    return {
        regimeFiscale: state.garanzie.regimeFiscale,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getRFDetails(id) {
            return dispatch(GaranzieActions.getRFDetails(id));
        },
        deleteRF(history) {
            return dispatch(GaranzieActions.deleteRF(history));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegimeFiscaleDetails);



